import { debounce } from "lodash/fp"
import * as React from "react"
import styled from "styled-components"
import media from "styleguide/styles/media-queries"
import MenuLinkTitle from "../MenuLinkTitle/MenuLinkTitle"

const MenuLinkWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
`

const MenuContent = styled.div`
  position: absolute;
  top: 33px;
  padding-top: 12px;
  z-index: 100;
  width: 220px;

  ${media.desktop`
    top: 17px;
  `}
`

interface Props {
  title: string
  content?: React.ReactNode
  url?: string
  externalLink?: boolean | false
  isCurrent?: boolean | false
}

const MenuLink = (props: Props) => {
  const menuRef = React.useRef(null)

  const [isContentShown, setIsContentShown] = React.useState<boolean>(false)

  const hideContent = debounce(1, () => {
    setIsContentShown(false)
  })

  const isContentRendered = !!props.content && isContentShown

  const showContent = () => {
    setIsContentShown(true)
  }

  React.useEffect(() => {
    if (!menuRef.current) {
      return
    }

    const { left, width } = menuRef.current.getBoundingClientRect()
    if (left + width > window.innerWidth) {
      menuRef.current.style.right = "0"
    } else {
      menuRef.current.style.left = "0"
    }
  }, [isContentRendered])

  return (
    <MenuLinkWrapper onMouseLeave={hideContent}>
      <MenuLinkTitle
        title={props.title}
        withChevron={!!props.content}
        isOpen={isContentRendered}
        isCurrent={props.isCurrent}
        to={props.url}
        onMouseOver={showContent}
        externalLink={props.externalLink}
      />
      {isContentRendered && (
        <MenuContent ref={menuRef}>{props.content}</MenuContent>
      )}
    </MenuLinkWrapper>
  )
}

export default MenuLink
